import React from 'react';
import { CurrencyCircleDollar, House, Phone, User } from '@phosphor-icons/react';

function formatCurrency(amount) {
  return `GHS ${amount.toLocaleString('en-GH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function HostelSection({ data }) {
  if (!data?.enrolled) {
    return (
      <div className="empty-state">
        <House size={40} weight="light" />
        <h3>Not Enrolled in Hostel</h3>
        <p>You are not currently enrolled in hostel accommodation</p>
      </div>
    );
  }

  return (
    <div className="hostel-section portal-section">
      {/* Hostel Information Card */}
      <div className="section-header">
        <h2>
          <House size={24} weight="duotone" />
          Hostel Information
        </h2>
      </div>

      <div className="info-grid">
        <div className="info-card">
          <label>Assigned Hostel</label>
          <p className="info-value">{data.hostel_id}</p>
        </div>
        <div className="info-card">
          <label>Room Number</label>
          <p className="info-value">{data.room_number}</p>
        </div>
        <div className="info-card">
          <label>Check-in Date</label>
          <p className="info-value">{new Date(data.assigned_date).toLocaleDateString()}</p>
        </div>
        <div className="info-card">
          <label>Academic Year</label>
          <p className="info-value">{data.academic_year}</p>
        </div>
      </div>

      {/* Contact Information */}
      <div className="contact-section">
        <h3>Contact Information</h3>
        <div className="contact-grid">
          {data.parent_contact && (
            <div className="contact-item">
              <User size={16} />
              <span>Parent: {data.parent_contact}</span>
            </div>
          )}
          {data.emergency_contact && (
            <div className="contact-item">
              <User size={16} />
              <span>Emergency: {data.emergency_contact}</span>
            </div>
          )}
          {data.emergency_contact_phone && (
            <div className="contact-item">
              <Phone size={16} />
              <span>{data.emergency_contact_phone}</span>
            </div>
          )}
        </div>
      </div>

      {/* Hostel Fees Section */}
      <div className="fees-section">
        <h3>
          <CurrencyCircleDollar size={20} weight="duotone" />
          Hostel Fee Status
        </h3>

        {data.recent_fees && data.recent_fees.length > 0 ? (
          <div className="fees-table-wrapper">
            <table className="fees-table">
              <thead>
                <tr>
                  <th>Fee Type</th>
                  <th>Due Date</th>
                  <th>Amount Due</th>
                  <th>Amount Paid</th>
                  <th>Balance</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data.recent_fees.map(fee => (
                  <tr key={fee.id}>
                    <td className="fee-type">{fee.fee_type}</td>
                    <td>{fee.due_date ? new Date(fee.due_date).toLocaleDateString() : 'N/A'}</td>
                    <td className="amount-due">{formatCurrency(fee.amount_due)}</td>
                    <td className="amount-paid">{formatCurrency(fee.amount_paid)}</td>
                    <td className="balance">{formatCurrency(fee.balance)}</td>
                    <td>
                      <span className={`badge ${fee.is_paid ? 'success' : 'warning'}`}>
                        {fee.is_paid ? 'Paid' : 'Pending'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="empty-fees">
            <p>No fees recorded for hostel</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default HostelSection;
